import * as React from "react";
import { IconPresentationProps } from "../Icon/Icon";

const Video: React.FC<IconPresentationProps> = props => {
    return (
        <svg
            focusable="false"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            role="img"
        >
            {props.title && <title>{props.title}</title>}
            <polygon points="23 7 16 12 23 17 23 7"></polygon>
            <rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect>
        </svg>
    );
};

export default React.memo(Video);
